import SurveyTicketHeader from "./SurveyTicketHeader";

export default SurveyTicketHeader;
